import { trigger, state, style, transition, animate } from '@angular/animations';

export const AnimationDurations = {
  TOOLBAR_SLIDE: 250,
  TOGGLE_CONTAINER: 500,
  ROTATION: 225,
  BANNER_SLIDE: 1000,
} as const;

export const Animations = {
  toggleContainer: trigger('toggleContainer', [
    state('true', style({ height: '*', padding: '*', overflow: 'hidden' })),
    state('false', style({ height: '0', padding: '0', visibility: 'hidden', overflow: 'hidden' })),
    transition(
      'true <=> false',
      animate(`${AnimationDurations.TOGGLE_CONTAINER}ms cubic-bezier(0.4, 0.0, 0.2, 1)`)
    ),
  ]),
  slideDown: trigger('slideDown', [
    state('true', style({ height: '*', padding: '*', overflow: 'hidden', opacity: 1 })),
    state(
      'false',
      style({ height: '0', padding: '0', visibility: 'hidden', overflow: 'hidden', opacity: 0 })
    ),
    transition('true <=> false', animate(`${AnimationDurations.TOOLBAR_SLIDE}ms ease-out`)),
  ]),
  rotatedState: trigger('rotatedState', [
    state('false', style({ transform: 'rotate(0deg)' })),
    state('true', style({ transform: 'rotate(90deg)' })),
    transition('true <=> false', animate(`${AnimationDurations.ROTATION}ms ease-out`)),
  ]),
  halfRotation: trigger('halfRotation', [
    state('false', style({ transform: 'rotate(0deg)' })),
    state('true', style({ transform: 'rotate(180deg)' })),
    transition('true <=> false', animate(`${AnimationDurations.ROTATION}ms ease-out`)),
  ]),
  slideFromTop: trigger('slideFromTop', [
    transition(':enter', [
      style({ transform: 'translateY(-100%)', opacity: 0 }),
      animate(
        `${AnimationDurations.BANNER_SLIDE}ms ease-out`,
        style({ transform: 'translateY(0)', opacity: 1 })
      ),
    ]),
  ]),
};
